export const EXSBINVOICEPOSITION_CREATE_RESET = 'EXSBINVOICEPOSITION_CREATE_RESET'
export const EXSBINVOICEPOSITION_CREATE_SET_CREATED = 'EXSBINVOICEPOSITION_CREATE_SET_CREATED'
export const EXSBINVOICEPOSITION_CREATE_SET_ERROR = 'EXSBINVOICEPOSITION_CREATE_SET_ERROR'
export const EXSBINVOICEPOSITION_CREATE_SET_VIOLATIONS = 'EXSBINVOICEPOSITION_CREATE_SET_VIOLATIONS'
export const EXSBINVOICEPOSITION_CREATE_TOGGLE_LOADING = 'EXSBINVOICEPOSITION_CREATE_TOGGLE_LOADING'
